<main #mainArea class="animated fadeInUp">
  <div class="custom-logo" *ngIf="whiteLabelService.customLoginLogoExists$ | async; else defaultLogo">
    <div>
      <img [src]="customLogoInfo.loginLogoPath" class="custom-img" />
      <img src="assets/img/amplogo-100.png" alt="{{ 'app.name' | transloco }}" class="amp" />
    </div>
  </div>

  <ng-template #defaultLogo>
    <img src="assets/img/amplogo.png" alt="{{ 'app.name' | transloco }}" class="logo" data-e2e="logo" />
  </ng-template>

  <form (keyup.enter)="submitLogin($event)" [formGroup]="loginForm">
    <avn-form-field [enableValidTheme]="false">
      <avn-input [translate]="'app.name'" [debounceTime]="500" type="text" [placeholder]="'login.username' | transloco" formControlName="username"></avn-input>
    </avn-form-field>
    <avn-form-field [enableValidTheme]="false">
      <avn-input type="password" [debounceTime]="500" [placeholder]="'login.password' | transloco" formControlName="password"> </avn-input>
    </avn-form-field>
    <avn-button *ngIf="theme$ | async" [disabled]="loginForm.invalid" avnTheme="primary" [label]="'login.button' | transloco" (actioned)="login()" data-e2e="login-button"></avn-button>
  </form>
  <div class="loadingContainer">
    <avn-icon *ngIf="pending$ | async" icon="fa:circle-o-notch" [rotate]="true"></avn-icon>
  </div>
</main>
<div class="lang-bar">
  <avn-icon icon="fa:language"></avn-icon>
  <div *ngFor="let lang of translate.getAvailableLangs()">
    <a (click)="setLang(lang.id)" [class.active]="lang.id === translate.getActiveLang()">{{ lang.label }}</a>
  </div>
</div>

<footer class="page-footer" [innerHTML]="'app.copyright' | transloco" data-e2e="page-footer"></footer>
